__turbopack_context__.v({
  "buttons": "styles-module-scss-module__gkkeUW__buttons",
  "center": "styles-module-scss-module__gkkeUW__center",
  "concession_note_container": "styles-module-scss-module__gkkeUW__concession_note_container",
  "directions_container": "styles-module-scss-module__gkkeUW__directions_container",
  "directions_link": "styles-module-scss-module__gkkeUW__directions_link",
  "mobile_button": "styles-module-scss-module__gkkeUW__mobile_button",
  "overview_heading": "styles-module-scss-module__gkkeUW__overview_heading",
  "refresh_date": "styles-module-scss-module__gkkeUW__refresh_date",
  "seller_concession_note": "styles-module-scss-module__gkkeUW__seller_concession_note",
  "summary": "styles-module-scss-module__gkkeUW__summary",
});
